import { AngleRight } from 'flowbite-react-icons/outline';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

ArrowRightButton.propTypes = {
  link: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.oneOf(['round', 'regular']),
  children: PropTypes.node,
  hover: PropTypes.bool,
};

export default function ArrowRightButton({
  link,
  style = 'round',
  children,
  hover,
  onClick,
}) {
  const handleOnClick = (e) => {
    e.preventDefault();
    onClick(e);
  };

  if (link) {
    if (style === 'round')
      return (
        <NavLink
          unstable_viewTransition
          to={link}
          className={`btn bg-base-200 border ${!hover & 'text-gray-600'} border-neutral-200 btn-circle btn-ghost hover:shadow-md hover:bg-secondary hover:text-white shadow-md ${hover && 'bg-secondary text-white shadow-md'}`}

          // className="btn bg-base-200 border border-neutral-200 btn-circle hover:shadow-md hover:bg-blue-500 hover:text-white"
        >
          <AngleRight />
        </NavLink>
      );

    return (
      <NavLink
        unstable_viewTransition
        to={link}
        className={`btn bg-base-200 border border-neutral-200 text-gray-600 btn-circle btn-ghost hover:shadow-md hover:bg-secondary hover:text-white ${hover && 'bg-secondary text-white shadow-md'}`}
      >
        {children}
        <AngleRight />
      </NavLink>
    );
  }

  return (
    <button
      className={`btn bg-base-200 border border-neutral-200 btn-circle btn-ghost hover:shadow-md hover:text-white hover:bg-secondary ${hover && 'sj-light-blue text-white shadow-md'}`}
      onClick={handleOnClick}
    >
      <AngleRight />
    </button>
  );
}
